import { render, staticRenderFns } from "./GoodsRanking.vue?vue&type=template&id=3a14bd8a&scoped=true"
import script from "./GoodsRanking.vue?vue&type=script&lang=ts"
export * from "./GoodsRanking.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=3a14bd8a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14bd8a",
  null
  
)

export default component.exports